import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = [
    'latinTextField'
  ];

  initialize() {
    window['typel_items'] = this;
    // TODO: This method is Not in use, remove
    // this.autoActivateTurkishToggleIfSpecificConditionsAreMet();
  }

  get specialArabicLetters() {
    return /[ثحخذصضطظغق]/;
  }

  get unconditionalLettersForTurkishToggle() {
    return /[ثخذض]/;
  }

  get specialArabicCombinations() {
    return ["با", "تا", "جا", "دا", "ذا", "زا", "سا", "شا", "فا", "كا", "لا", "ما", "نا", "وا", "ها", "را", "یا"];
  }

  get arabicOttomanEndingExceptions() {
    return ['را', 'یا'];
  }

  get specialPersianCombinations() {
    return ["پا", "چا،", "ژا"];
  }

  // TODO: This method is Not in use, remove
  // autoActivateTurkishToggleIfSpecificConditionsAreMet() {
  //   document.querySelectorAll('.js-typing-value-container').forEach(typingValueContainer => {
  //     const arabicToggle   = this.getOttomanSpellingArabicToggle(typingValueContainer);
  //     const persianToggle  = this.getOttomanSpellingPersianToggle(typingValueContainer);
      
  //     const ottomanSpellingField = typingValueContainer.querySelector('.js-otto-field');
  //     const ottomanFieldValue    = this.getElementValue(ottomanSpellingField);

  //     if (persianToggle.checked) {
  //       if (this.specialPersianCombinationsExist(ottomanFieldValue)) {
  //         this.turnOnTurkishToggleForAllSpellingFields(typingValueContainer);
  //         return
  //       }
  //     }
      
  //     if (arabicToggle.checked) {
  //       this.turnOnTurkishToggleForSpecificSpellingFields(typingValueContainer, ottomanFieldValue);
  //     }     
  //   });
  // }

  getElementValue(element) {
    if (!element) return '';
    
    // If element has value property, use it; otherwise use textContent
    return (element.value !== undefined ? element.value : element.textContent).trim();
  }  

  specialArabicLettersOrCombinationsExist(ottomanValue) {
    if (this.specialArabicLetters.test(ottomanValue)) {
      return true;
    }

    for (const combo of this.specialArabicCombinations) {
      if (ottomanValue.includes(combo)) {
        return true;
      }
    }

    return false;
  }

  unconditionalLettersForTurkishToggleExist(ottomanValue) {
    if (this.unconditionalLettersForTurkishToggle.test(ottomanValue)) {
      return true;
    }    
  }

  hasArabicOttomanEndingExceptions(ottomanValue) {
    if (!ottomanValue) return false;
    
    return this.arabicOttomanEndingExceptions.some(exception => 
      ottomanValue.endsWith(exception)
    );
  }

  specialPersianCombinationsExist(ottomanValue) {
    for (const combo of this.specialPersianCombinations) {
      if (ottomanValue.includes(combo)) {
        return true;
      }
    }

    return false 
  }

  currentTargetIsLatinField(target) {
    return target?.dataset?.typelItemsTarget?.includes("latinTextField")
  }

  activateTurkishToggleIfRequired(e) {
    const currentTarget        = e.target;
    const typingValueContainer = currentTarget.closest('.js-typing-value-container');

    const arabicToggle   = this.getOttomanSpellingArabicToggle(typingValueContainer);
    const persianToggle  = this.getOttomanSpellingPersianToggle(typingValueContainer);

    const ottomanSpellingField = typingValueContainer.querySelector('.js-otto-field');
    const ottomanFieldValue    = this.getElementValue(ottomanSpellingField); 

    if (this.currentTargetIsLatinField(currentTarget) || (currentTarget.classList.contains('js-otto-spelling-pronunciation-toggle') && currentTarget.checked)) {
      const latinFieldContainer = currentTarget.closest('.js-entries-input');
      const spellingToggle      = this.getSpellingToggle(latinFieldContainer);

      if (this.currentTargetIsLatinField(currentTarget) && !spellingToggle.checked) return;

      const latinField    = latinFieldContainer.querySelector('.js-latin-text-field')
      const latinValue    = latinField.value.trim();
      
      const turkishToggle = this.getTurkishToggle(latinFieldContainer);
      
      if (turkishToggle && !turkishToggle.checked) {
        if (this.unconditionalLettersForTurkishToggleExist(ottomanFieldValue) || (arabicToggle.checked && this.specialArabicLettersOrCombinationsExist(ottomanFieldValue) && !(this.hasArabicOttomanEndingExceptions(ottomanFieldValue) && latinValue.endsWith('n')))) {
          turkishToggle.checked = true;
          return;
        }

        if (arabicToggle.checked && ottomanFieldValue.includes('و') && latinValue.includes('v')) {
          turkishToggle.checked = true;
          return;
        }
      } else if (turkishToggle.checked && (this.hasArabicOttomanEndingExceptions(ottomanFieldValue) && latinValue.endsWith('n'))) {
        turkishToggle.checked = false;
      }
    } else {
      // This rule is not required now, remove once its testing is complete by Ahmet
      // if (currentTarget === persianToggle && persianToggle.checked) {
      //   if (this.specialPersianCombinationsExist(ottomanFieldValue)) {
      //     this.turnOnTurkishToggleForAllSpellingFields(typingValueContainer);
      //     return
      //   }
      // }

      if (currentTarget === arabicToggle && arabicToggle.checked) {
        this.turnOnTurkishToggleForSpecificSpellingFields(typingValueContainer, ottomanFieldValue);
      }
    }
  }

  // Rule: Exemption for Words Ending in 'n'
  // If an Ottoman word is labeled as Arabic,
  // and it ends with specialArabicCombinations
  // and its Latin value marked as spelling ends with the letter "n",
  // then the Turkish toggle should not be automatically activated.
  turnOnTurkishToggleForSpecificSpellingFields(typingValueContainer, ottomanValue) {
    const fieldsMarkedAsSpellingContainers = Array.from(
      typingValueContainer.querySelectorAll('.js-otto-spelling-pronunciation-toggle:checked')
    ).map(toggle => toggle.closest('.js-entries-input'));

    fieldsMarkedAsSpellingContainers.forEach((latinContainer) => {
      const turkishToggle = latinContainer.querySelector('.js-turkish-toggle');

      if (turkishToggle && !turkishToggle.checked) {
        const latinField = latinContainer.querySelector('.js-latin-text-field')
        const latinValue = latinField.value.trim();

        if (this.specialArabicLettersOrCombinationsExist(ottomanValue) && !(this.hasArabicOttomanEndingExceptions(ottomanValue) && latinValue.endsWith('n'))) {
          turkishToggle.checked = true;
          return;
        }
        
        if (ottomanValue.includes('و') && latinValue.includes('v')) {
          turkishToggle.checked = true;
          return;
        }
      }
    }); 
  }

  turnOnTurkishToggleForAllSpellingFields(typingValueContainer) {
    typingValueContainer.querySelectorAll('.js-otto-spelling-pronunciation-toggle:checked')
      .forEach(toggle => {
        const latinFieldContainer = toggle.closest('.js-entries-input');
        const turkishToggle = latinFieldContainer?.querySelector('.js-turkish-toggle');

        if (turkishToggle && !turkishToggle.checked) {
          turkishToggle.checked = true;
        }
    });
  }

  getOttomanSpellingPersianToggle(container) {
     return container.querySelector('.js-marked-as-persian-toggle');
  }

  getOttomanSpellingArabicToggle(container) {
     return container.querySelector('.js-marked-as-arabic-toggle');
  }  

  getOttomanSpellingNoHarakatToggle(container) {
    return container.querySelector('.js-marked-as-no-harakat-toggle');
  }

  getSpellingToggle(container) {
    return container.querySelector('.js-otto-spelling-pronunciation-toggle');
  }

  getTurkishToggle(container) {
    return container.querySelector('.js-turkish-toggle');
  }

  getLikelyToggle(container) {
    return container.querySelector('.js-likely-toggle');
  }

  getPossibleToggle(container) {
    return container.querySelector('.js-possible-toggle');
  }

  getUnlikelyToggle(container) {
    return container.querySelector('.js-unlikely-toggle');
  }

  getMispronunciationToggle(container) {
    return container.querySelector('.js-mispronounced-toggle');
  }

  getCloseToAccurateToggle(container) {
    return container.querySelector('.js-close-to-accurate-toggle');
  }

  getRelatedToggle(container) {
    return container.querySelector('.js-related-toggle');
  }

  getLqToggle(container) {
    return container.querySelector('.js-marked-nonstandard-by-lq-toggle');
  }

  getAuthorToggle(container) {
    return container.querySelector('.js-marked-nonstandard-by-author-toggle');
  }

  getVulgarToggle(container) {
    return container.querySelector('.js-vulgar-toggle');
  }

  getVisibleLatinFields() {
    return $('.js-latin-entries-input').filter(function() {
      return $(this).is(':visible') && !$(this).hasClass('d-none');
    });
  }

  getVisibleLatinFieldsInContainer(container) {
    return $(container).find('.js-latin-entries-input').filter(function() {
      return $(this).is(':visible') && !$(this).hasClass('d-none');
    });
  }  

  // Turkish toggle dependency on Spelling toggle
  handleTurkishSpellingToggleDependency(e) {
    const currentTarget    = e.currentTarget;
    const togglesContainer = currentTarget.closest('.js-typel-toggle-container');
    
    if (!togglesContainer) return;

    const spellingToggle = this.getSpellingToggle(togglesContainer);
    const turkishToggle  = this.getTurkishToggle(togglesContainer);
    
    if (!spellingToggle || !turkishToggle) return;

    if (currentTarget === turkishToggle && turkishToggle.checked) {
      if (!spellingToggle.disabled) {
        spellingToggle.checked = true;
      } else {
        turkishToggle.checked = false; // disable case → revert Turkish toggle
      }
    } else if (currentTarget === spellingToggle && !spellingToggle.checked) {
      turkishToggle.checked = false;
    }
  }

  // Likely, Possible, and Unlikely toggles are mutually exclusive
  handleExclusivityOfLikelyUnlikelyAndPossibleToggles(e) {
    const currentTarget    = e.currentTarget;
    const togglesContainer = currentTarget.closest('.js-typel-toggle-container');
    
    if (!togglesContainer) return;

    const likelyToggle   = this.getLikelyToggle(togglesContainer)
    const possibleToggle = this.getPossibleToggle(togglesContainer)
    const unlikelyToggle = this.getUnlikelyToggle(togglesContainer)

    if (currentTarget === likelyToggle) {
      if (possibleToggle && possibleToggle.checked) {
        possibleToggle.checked = false;
      }
      if (unlikelyToggle && unlikelyToggle.checked) {
        unlikelyToggle.checked = false;
      }
    } else if (currentTarget === possibleToggle) {
      if (likelyToggle && likelyToggle.checked) {
        likelyToggle.checked = false;
      }
      if (unlikelyToggle && unlikelyToggle.checked) {
        unlikelyToggle.checked = false;
      }
    } else if (currentTarget === unlikelyToggle) {
      if (likelyToggle && likelyToggle.checked) {
        likelyToggle.checked = false;
      }
      if (possibleToggle && possibleToggle.checked) {
        possibleToggle.checked = false;
      }
    }
  }

  // Sorting logic for Spelling/Likely/Unlikely/MisP toggles
  // - Spelling
  // - Likely
  // - Neither likely nor unlikely
  // - Unlikely  
  
  // Dynamic Sorting Logic:

  // Likely ON →
  // Moves the item below the last Spelling-tagged value (or below the last Likely-tagged value if others exist).

  // Likely OFF →
  // Moves the item to the top of the Neither likely nor unlikely block.

  // Unlikely ON →
  // Sends the item to the very end of the list.

  // Unlikely OFF →
  // Moves the item to the top of the Neither likely nor unlikely block.
  sortFieldsGroupedByToggles(e = null) {
    if (e) {
      this.reorderAllAlternativeFields(e);
    } else {
      const allContainers = document.querySelectorAll('.js-simple-sortable-values');
      allContainers.forEach(container => {
        this.reorderAllAlternativeFields(null, container);
      });
    }
  }

  reorderAllAlternativeFields(e = null, providedContainer = null) {
    let container;
    
    if (providedContainer) {
      container = providedContainer;
    } else if (e) {
      const currentTarget = e.target;
      container = currentTarget.closest('.js-simple-sortable-values');
    } else {
      return;
    }

    if (!container) return;

    const allFields      = Array.from(container.querySelectorAll('.js-alternate-latin-values'));
    const toggledElement = e ? e.currentTarget : null;
    const toggledField   = toggledElement ? toggledElement.closest('.js-alternate-latin-values') : null;

    const PRIMARY_PRIORITIES = {
      'spelling': 1,        // Spelling group comes first
      'non-spelling': 2     // Non-spelling group comes second
    };

    const SECONDARY_PRIORITIES = {
      'likely': 1,          // Within each primary group, likely comes first
      'neutral': 2,         // Then neutral
      'unlikely': 3,        // Then unlikely
      'mispronounced': 4    // Then mispronounced
    };

    const sortLatinFieldsBlock = (fields) => {
      return fields.sort((a, b) => {
        const aValue = parseInt(a.querySelector('input[name*="[alternative_assigned_value]"]').value, 10);
        const bValue = parseInt(b.querySelector('input[name*="[alternative_assigned_value]"]').value, 10);
        return aValue - bValue;
      });
    }

    const getFieldPriorities = (field) => {
      const isSpelling      = field.querySelector('.js-otto-spelling-pronunciation-toggle')?.checked;
      const isLikely        = field.querySelector('.js-likely-toggle')?.checked;
      const isUnlikely      = field.querySelector('.js-unlikely-toggle')?.checked;
      const isMispronounced = field.querySelector('.js-mispronounced-toggle')?.checked;

      const primaryPriority = isSpelling ? PRIMARY_PRIORITIES['spelling'] : PRIMARY_PRIORITIES['non-spelling'];
      
      // Secondary priority (likely, neutral, unlikely, mispronounced)
      let secondaryPriority;
      if (isLikely) {
        secondaryPriority = SECONDARY_PRIORITIES.likely;
      } else if (isUnlikely) {
        secondaryPriority = SECONDARY_PRIORITIES.unlikely;
      } else if (isMispronounced) {
        secondaryPriority = SECONDARY_PRIORITIES.mispronounced;
      } else {
        secondaryPriority = SECONDARY_PRIORITIES.neutral;
      }

      return {
        primary: primaryPriority,
        secondary: secondaryPriority,
        combined: `${primaryPriority}.${secondaryPriority}`
      };
    };

    // Handle special cases for recently changed fields
    let fieldThatBecameNeutral = null;
    let fieldThatBecameUnlikely = null;
    let fieldThatBecameMispronounced = null;

    if (toggledElement && toggledField) {
      const isNowNeutral = !toggledField.querySelector('.js-otto-spelling-pronunciation-toggle')?.checked &&
                           !toggledField.querySelector('.js-likely-toggle')?.checked &&
                           !toggledField.querySelector('.js-possible-toggle')?.checked &&
                           !toggledField.querySelector('.js-unlikely-toggle')?.checked &&
                           !toggledField.querySelector('.js-mispronounced-toggle')?.checked;
      
      const justBecameUnlikely = toggledElement.classList.contains('js-unlikely-toggle') && toggledElement.checked;
      const justBecameMispronounced = toggledElement.classList.contains('js-mispronounced-toggle') && toggledElement.checked;

      if (isNowNeutral) {
        const wasLikely        = toggledElement.classList.contains('js-likely-toggle') && !toggledElement.checked;
        const wasPossible      = toggledElement.classList.contains('js-possible-toggle') && !toggledElement.checked;
        const wasUnlikely      = toggledElement.classList.contains('js-unlikely-toggle') && !toggledElement.checked;
        const wasMispronounced = toggledElement.classList.contains('js-mispronounced-toggle') && !toggledElement.checked;
        
        if (wasLikely || wasPossible || wasUnlikely || wasMispronounced) {
          fieldThatBecameNeutral = toggledField;
        }
      } else if (justBecameUnlikely) {
        fieldThatBecameUnlikely = toggledField;
      } else if (justBecameMispronounced) {
        fieldThatBecameMispronounced = toggledField;
      }
    }

    // Group fields by combined priority
    const fieldsByGroup = {};

    // Categorize all fields except special ones
    allFields.forEach(field => {
      if (field === fieldThatBecameNeutral || field === fieldThatBecameUnlikely || field === fieldThatBecameMispronounced) return;
      
      const priorities = getFieldPriorities(field);
      const groupKey = priorities.combined;
      
      if (!fieldsByGroup[groupKey]) {
        fieldsByGroup[groupKey] = [];
      }
      fieldsByGroup[groupKey].push(field);
    });

    // Handle special fields
    if (fieldThatBecameNeutral) {
      const priorities = getFieldPriorities(fieldThatBecameNeutral);
      const groupKey = priorities.combined;
      if (!fieldsByGroup[groupKey]) fieldsByGroup[groupKey] = [];
      fieldsByGroup[groupKey].unshift(fieldThatBecameNeutral);
    }
    
    if (fieldThatBecameUnlikely) {
      const priorities = getFieldPriorities(fieldThatBecameUnlikely);
      const groupKey = priorities.combined;
      if (!fieldsByGroup[groupKey]) fieldsByGroup[groupKey] = [];
      fieldsByGroup[groupKey].push(fieldThatBecameUnlikely);
    }
    
    if (fieldThatBecameMispronounced) {
      const priorities = getFieldPriorities(fieldThatBecameMispronounced);
      const groupKey = priorities.combined;
      if (!fieldsByGroup[groupKey]) fieldsByGroup[groupKey] = [];
      fieldsByGroup[groupKey].push(fieldThatBecameMispronounced);
    }

    // Sort groups by combined priority and combine
    const sortedFields = [];
    
    Object.keys(fieldsByGroup)
      .sort((a, b) => {
        const [aPrimary, aSecondary] = a.split('.').map(Number);
        const [bPrimary, bSecondary] = b.split('.').map(Number);

        if (aPrimary !== bPrimary) {
          return aPrimary - bPrimary;
        }
        return aSecondary - bSecondary;
      })
      .forEach(groupKey => {
        const fieldsInGroup = fieldsByGroup[groupKey];
        if (fieldsInGroup.length > 0) {
          sortedFields.push(...sortLatinFieldsBlock(fieldsInGroup));
        }
      });

    sortedFields.forEach((field, index) => {
      const assignedValueInput = field.querySelector('input[name*="[alternative_assigned_value]"]');
      if (assignedValueInput) {
        assignedValueInput.value = index;
      }
      container.appendChild(field);
    });
  }

  autoActivateLikelyTogglesIfSingleField() {
    // Single Latin transcription no longer gets Likely turned on before save. Ref # CPG-534 | Ticket # https://evolving-bits.atlassian.net/browse/CPG-534
    // Remove this return to restore that behavior.
    return;

    const ottomanLatinContainers = document.querySelectorAll('.js-typing-value-container');
    ottomanLatinContainers.forEach(container => {
      const $typing_fields = this.getVisibleLatinFieldsInContainer(container);

      if ($typing_fields.length === 1) {
        const first_field         = $typing_fields[0];
        const $likelyToggle       = $(first_field).find('.js-likely-toggle');

        if (!$likelyToggle.prop('checked')) {
          $likelyToggle.prop('checked', true).trigger('change');
        }
      }
    });
  }

  applyLatinFieldToggleRules() {
    this.autoActivateLikelyTogglesIfSingleField();
    this.sortFieldsGroupedByToggles();
  }  

  // This method is commented out but kept for reference.  
  // A new optimized method(with same name) with additional rules has been added.  
  // TODO: Remove this method once the new one is confirmed stable.  
  // Handle LQ/Auth and Misp/Vulg/Cl.Acc. with their dependencies.
  // handleNonstandardTogglesStateChanges(e) {
  //   const currentTarget = e.currentTarget;
  //   const container     = currentTarget.closest('.js-entries-input');
  //   if (!container) return;

  //   const mispToggle  = this.getMispronunciationToggle(container);
  //   const clAccToggle = this.getCloseToAccurateToggle(container);
  //   const vulgToggle  = this.getVulgarToggle(container);
  //   const lqToggle    = this.getLqToggle(container);
  //   const authToggle  = this.getAuthorToggle(container);

  //   // Check which toggles exist in this container
  //   const hasMispronounced   = mispToggle != null;
  //   const hasCloseToAccurate = clAccToggle != null;
  //   const hasVulgar          = vulgToggle != null;
  //   const hasLq              = lqToggle != null;
  //   const hasAuth            = authToggle != null;

  //   // If we don't have the required toggles, exit early
  //   if (!hasLq || !hasAuth || !hasVulgar) return;
    
  //   const isMispronouncedOrVulgarOrCloseToAccurate = (hasMispronounced && mispToggle.checked) || (hasVulgar && vulgToggle.checked) || (hasCloseToAccurate && clAccToggle.checked);
  //   const isAuthOrLQ              = (hasAuth && authToggle.checked) || (hasLq && lqToggle.checked);

  //   // LQ checked: Only allow if MisP. or Vulg. or ClAcc. is checked, otherwise revert; also uncheck Auth if MisP./Vulg./ClAcc. is checked
  //   if (currentTarget === lqToggle && currentTarget.checked) {
  //     if (isMispronouncedOrVulgarOrCloseToAccurate) {
  //       authToggle.checked = false;
  //     } else if(!isMispronouncedOrVulgarOrCloseToAccurate) {
  //       currentTarget.checked = false;
  //     }
  //   // LQ unchecked: If MisP. or Vulg. or ClAcc. is checked, uncheck them; if neither is checked, revert checking LQ
  //   } else if (currentTarget === lqToggle && !currentTarget.checked) {
  //     if (isMispronouncedOrVulgarOrCloseToAccurate) {
  //       if (hasMispronounced && mispToggle.checked) mispToggle.checked = false;
  //       if (hasVulgar && vulgToggle.checked) vulgToggle.checked = false;
  //       if (hasCloseToAccurate && clAccToggle.checked) clAccToggle.checked = false;
  //     }
  //   }

  //   // Auth checked: Only allow if MisP. or Vulg. or Cl.Acc. is checked, otherwise revert; also uncheck LQ if MisP./Vulg./Cl.Acc .is checked
  //   if (currentTarget === authToggle && currentTarget.checked) {
  //     if (isMispronouncedOrVulgarOrCloseToAccurate) {
  //       lqToggle.checked = false;
  //     } else if(!isMispronouncedOrVulgarOrCloseToAccurate) {
  //       currentTarget.checked = false;
  //     }
  //   // Auth unchecked: If MisP. or Vulg. or Cl.Acc. is checked, uncheck them; if neither is checked, revert checking Auth
  //   } else if (currentTarget === authToggle && !currentTarget.checked) {
  //     if (isMispronouncedOrVulgarOrCloseToAccurate) {
  //       if (hasMispronounced && mispToggle.checked) mispToggle.checked = false;
  //       if (hasVulgar && vulgToggle.checked) vulgToggle.checked = false;
  //       if (hasCloseToAccurate && clAccToggle.checked) clAccToggle.checked = false;
  //     }
  //   }

  //   // MisP. or Vulg. or Cl.Acc. checked: If neither Auth nor LQ is checked, auto-check Auth
  //   if ((currentTarget === mispToggle || currentTarget === vulgToggle || currentTarget === clAccToggle) && currentTarget.checked) {
  //     if (!isAuthOrLQ) {
  //       authToggle.checked = true;
  //     }
  //   // MisP. or Vulg. or Cl.Acc. unchecked: If both are now unchecked, uncheck both Auth and LQ
  //   } else if ((currentTarget === mispToggle || currentTarget === vulgToggle || currentTarget === clAccToggle) && !currentTarget.checked) {
  //     // Check if all MisP. and Vulg. and Cl.Acc. are now unchecked
  //     const allMispronouncedAndVulgarAndClAccUnchecked = (!hasMispronounced || !mispToggle.checked) && (!hasVulgar || !vulgToggle.checked) && (!hasCloseToAccurate || !clAccToggle.checked);
      
  //     if (allMispronouncedAndVulgarAndClAccUnchecked) {
  //       // If all MisP. and Vulg. and Cl.Acc. are unchecked, uncheck both Auth. and LQ
  //       if (hasAuth && authToggle.checked) authToggle.checked = false;
  //       if (hasLq && lqToggle.checked) lqToggle.checked = false;
  //     }
  //   }

  //   this.updateMarkedNonstandardByField(container, lqToggle, authToggle);
  // }

  // Handle LQ/Auth and Misp/Vulg/Cl.Acc. with their dependencies.  
  handleNonstandardTogglesStateChanges(e) {
    const currentTarget = e.currentTarget;
    const container     = currentTarget.closest('.js-entries-input');
    if (!container) return;

    const mispToggle  = this.getMispronunciationToggle(container);
    const clAccToggle = this.getCloseToAccurateToggle(container);
    const vulgToggle  = this.getVulgarToggle(container);
    const lqToggle    = this.getLqToggle(container);
    const authToggle  = this.getAuthorToggle(container);

    const hasVulgar          = vulgToggle != null;
    const hasLq              = lqToggle != null;
    const hasAuth            = authToggle != null;

    if (!hasLq || !hasAuth || !hasVulgar) return;

    const attributeToggles = [mispToggle, vulgToggle, clAccToggle].filter(Boolean);
    const anyAttributeToggleChecked    = () => attributeToggles.some(t => t.checked);
    const allAttributeTogglesUnchecked = () => attributeToggles.every(t => !t.checked);
    const isAuthOrLQ = (hasAuth && authToggle.checked) || (hasLq && lqToggle.checked);

    // LQ toggle behavior
    if (currentTarget === lqToggle) {
      if (currentTarget.checked) {
        if (anyAttributeToggleChecked()) {
          authToggle.checked = false;
        } else {
          currentTarget.checked = false;
        }
      } else {
        if (anyAttributeToggleChecked()) attributeToggles.forEach(t => { if (t.checked) t.checked = false; });
      }
    }

    // Auth toggle behavior
    if (currentTarget === authToggle) {
      if (currentTarget.checked) {
        if (anyAttributeToggleChecked()) {
          lqToggle.checked = false;
        } else {
          currentTarget.checked = false;
        }
      } else {
        if (anyAttributeToggleChecked()) attributeToggles.forEach(t => { if (t.checked) t.checked = false; });
      }
    }

    // Group (MisP/Vulg/ClAcc) behavior
    if (attributeToggles.includes(currentTarget)) {
      if (currentTarget.checked) {
        if (!isAuthOrLQ) authToggle.checked = true;
      } else {
        if (allAttributeTogglesUnchecked()) {
          if (hasAuth && authToggle.checked) authToggle.checked = false;
          if (hasLq && lqToggle.checked) lqToggle.checked = false;
        }
      }
    }

    this.updateMarkedNonstandardByField(container, lqToggle, authToggle);
  }

  updateMarkedNonstandardByField(container, lqToggle, authToggle) {
    const hiddenField = container.querySelector('.js-marked-nonstandard-by');
    if (!hiddenField) return;

    if (lqToggle && lqToggle.checked) {
      hiddenField.value = "lexiqamus"
    } else if (authToggle && authToggle.checked) {
      hiddenField.value = "author"
    } else {
      hiddenField.value = ""
    }
  }  
}